import { render, staticRenderFns } from "./MatrixViewComponent.vue?vue&type=template&id=5d9a81a8&scoped=true&"
import script from "./MatrixViewComponent.vue?vue&type=script&lang=js&"
export * from "./MatrixViewComponent.vue?vue&type=script&lang=js&"
import style0 from "./MatrixViewComponent.vue?vue&type=style&index=0&id=5d9a81a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a81a8",
  null
  
)

export default component.exports